import Page from './Page';
import reducer from './reducer';

export const reducers = { CourseLanguageManager: reducer };
export default { Page, reducers };